import React from 'react';
import PropTypes from 'prop-types';

// Possible styles of icons
const STYLES_MAP = {
  solid: 'fas',
  regular: 'far',
  light: 'fal',
  duotone: 'fad',
  brands: 'fab',
};

const Icon = (props) => {
  const { name, className, type, fixedSize, size, spin, style, onClick } = props;
  const styles = style ? style : {};

  if (fixedSize) {
    styles.width = size;
    styles.height = size;
    styles.textAlign = 'center';
    styles.verticalAlign = 'middle';
  }

  return (
    <i
      style={styles}
      onClick={onClick}
      className={`${STYLES_MAP[type]} fa-${name} ${className ? className : ''} ${spin ? 'fa-spin' : ''}`}
    />
  );
};

export default Icon;

// Default props for icons: solid style and default size 16px for fixed sized icons.
Icon.defaultProps = {
  type: 'regular',
  size: 16,
  spin: false,
};
Icon.propTypes = {
  style: PropTypes.object,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  type: PropTypes.oneOf(['solid', 'regular', 'light', 'brands', 'duotone']),
  fixedSize: PropTypes.bool,
  size: PropTypes.number,
  spin: PropTypes.bool,
  onClick: PropTypes.func,
};
